<template>
  <BaiduMap 
    class="map" 
    ak="ndYEn2os3DVI5fW83tzaUkD4"
    :center="mapCenter" 
    :zoom="mapZoom"
    @ready="mapReady">
    <bm-marker :position="mapCenter" @click="onClick" v-if="showMarker">
    </bm-marker>
    <bm-info-window :position="mapCenter" 
      v-if="showMarker"
      :show="showInfo"
      @close="infoWindowClose"
      :width="260">{{ name }}</bm-info-window>
  </BaiduMap>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker' // 标记点的组件
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow';
export default {
  props: {
    name: {
      type: String,
      default: '杭州市西湖区保俶路238号南2楼'
    },
    showMarker:{
      default: () => false
    },
    mapCenter: {
      default: () => ({lng: 120.152799, lat: 30.277599})
    }
  },
  data() {
    return {
      mapZoom: 3,
      showInfo: true
    }
  },
  components: {
    BaiduMap,
    BmMarker,
    BmInfoWindow
  },
  methods: {
    mapReady() {
      this.mapZoom = 15
    },
    infoWindowClose() {
      this.showInfo = false;
    },
    onClick() {
      this.showInfo = true;
    }
  }
}
</script>